import React,{useState} from 'react';
import { Link ,useNavigate} from 'react-router-dom';
import { getAuth, createUserWithEmailAndPassword, updateProfile } from "firebase/auth";
import { doc, setDoc } from 'firebase/firestore';
import {db} from '../../firebase/Config'
import LoadingForAll from '../../Pages/LoadingForAll';
import './SignUp.css'
const SignuUpPage = () => {
const navigate = useNavigate()
    const [name,setName] = useState('')
    const [email,setEmail] = useState('')
    const [password,setPassword] = useState('')
    const [phone, setPhone] = useState('')
    const [signErr,setSignErr] = useState('')
    const [load,setLoad] = useState(false)
    const handleSubmit=async(e)=>{
        e.preventDefault()
        setSignErr('')
      
      try{
        setLoad(true)
        const auth=getAuth()
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      
      // Update user profile with display name
      await updateProfile(userCredential.user, {
        displayName: name
      });

      // Add user data to Firestore using UID as document ID
      await setDoc(doc(db, 'users', userCredential.user.uid), {
        id: userCredential.user.uid,
        username: name,
        email: email,
        isAdmin: false,
        phone: phone,
        createdAt: new Date()
      });

     setLoad(false)
      navigate('/');
        }catch(err){
           alert(err.message)
           setLoad(false)
           navigate('/signup')
         setSignErr(err.message)
        }
    }
  return (

    <section className="vh-100">
      <div className="container-fluid h-custom">
        <div className="row d-flex justify-content-center align-items-center h-100">
          <div className="col-md-9 col-lg-6 col-xl-5">
            <img 
              src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-login-form/draw2.webp"
              className="img-fluid" 
              alt="Sample" 
            />
          </div>
          <div className="col-md-8 col-lg-6 col-xl-4 offset-xl-1">
            <form onSubmit={handleSubmit}>
              <div className="divider d-flex align-items-center my-4">
                <p className="text-center fw-bold mx-3 mb-0" style={{fontSize: '35px', color: 'blue'}}>
                  Sign up
                </p>
              </div>
              {signErr&&<div>{signErr}</div>}
              {/* Name input */}
              <div className="form-outline mb-4">
              <label className="form-label" htmlFor="form3Example3">Surname</label>
                <input 
                  type="text" 
                  id="form3Example3" 
                  className="form-control form-control-lg" 
                  name="Surname"
                  value={name}
                  onChange={(e)=>setName(e.target.value)}
                  placeholder="Enter your name" 
                />
              
              </div>

               {/* phone input */}
              <div className="form-outline mb-4">
              <label className="form-label" htmlFor="form3Example3">Phone number</label>
                <input 
                  type="number" 
                  id="form3Example3" 
                  className="form-control form-control-lg" 
                  name="phone"
                  value={phone}
                  onChange={(e)=>setPhone(e.target.value)}
                  placeholder="Enter your phone number" 
                />
                
              </div>

              {/* Email input */}
              <div className="form-outline mb-4">
              <label className="form-label" htmlFor="form3Example3">Email address</label>
                <input 
                  type="email" 
                  id="form3Example3" 
                  className="form-control form-control-lg" 
                  name="Email"
                  value={email}
                  onChange={(e)=>setEmail(e.target.value)}
                  placeholder="Enter a valid email address" 
                />
                
              </div>

              {/* Password input */}
              <div className="form-outline mb-3">
              <label className="form-label" htmlFor="form3Example4">Password</label>
                <input 
                  type="password" 
                  id="form3Example4" 
                  className="form-control form-control-lg" 
                  name="Password"
                  value={password}
                  onChange={(e)=>setPassword(e.target.value)}
                  placeholder="Enter password" 
                />
                
              </div>

              <div className="d-flex justify-content-between align-items-center">
                
                <button 
                  type="submit" 
                  className="btn btn-primary btn-lg"
                  style={{paddingLeft: '2.5rem', paddingRight: '2.5rem'}}
                >
                  Signup
                </button>
               
               
      {load&& <LoadingForAll title='Creating your account...'></LoadingForAll>}
                <p className="small fw-bold mt-2 pt-1 mb-0" style={{fontSize: '16px'}}>
                  I have an account.
                  <Link to="/login" className="link-danger " style={{textDecoration: 'underline',color:'blue'}}> Login?</Link>
                </p>
                
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SignuUpPage;